import { IRole } from '@tickeat/permissions';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const roleApi = crudEndpointsFactory<IRole>()('roles', 'Roles');
